import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import { SelectOption } from './registration-integration-form';
import CustomReactSelect from '@ui/select/react-select/custom-react-select';
import { reactSelectAdminStyles } from '@ui/select/react-select/react-select-styles';
import { TempRegField } from '@/utils/integrations';
import { ChangeEvent } from 'react';
import OptionalComponent from '@ui/optional-component/optional-component';
import Button from '@ui/buttons/button/button';

interface Props {
  channelRegistrationQuestions?: SelectOption[];
  optionsMap?: Record<string, SelectOption>;
  setQuestion: (field: string, value: string) => void;
  field: TempRegField;
  error: boolean;
  isKeyError?: boolean;
  deleteQuestion: () => void;
  disabled?: boolean;
}

const QuestionMapping = ({
  channelRegistrationQuestions = [],
  optionsMap,
  setQuestion,
  field,
  error,
  deleteQuestion,
  disabled,
}: Props) => {
  const handleQuestionLabel = (newValue: unknown): void => {
    const value = newValue as SelectOption;
    setQuestion(value.value.toString(), field.value);
  };

  const handleQuestionInput = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setQuestion(field.field.toString(), value);
  };

  const value = optionsMap?.[field.field] || null;

  return (
    <div className="grid-row margin-b-16">
      <CustomReactSelect
        value={value}
        menuPlacement="top"
        styles={reactSelectAdminStyles({
          container: () => ({ height: '46px' }),
          control: () => ({
            paddingLeft: '0',
            height: '100%',
            maxHeight: '100%',
            ...(error ? { border: '1px solid var(--semantic-red-400)' } : {}),
          }),
          menuList: () => ({ backgroundColor: 'var(--gray-800)', maxHeight: '300px' }),
          option: () => ({ height: '36px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }),
        })}
        options={channelRegistrationQuestions}
        closeMenuOnSelect
        onChange={handleQuestionLabel}
        isDisabled={disabled}
      />

      <InputWithOverlay
        inputProps={{
          id: field.id,
          onBlur: handleQuestionInput,
          defaultValue: field.value,
          placeholder: 'Enter a mapped value',
          disabled,
        }}
        error={error}
      />

      <OptionalComponent display={!disabled}>
        <Button clear className="flex fd-column jc-center" onClick={deleteQuestion}>
          <Icon name={ICONS.CLOSE} size={14} color={'var(--white)'} />
        </Button>
      </OptionalComponent>
    </div>
  );
};

export default QuestionMapping;
